/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiConfig } from '@/configs/appConfig'
import axios from 'axios'

import { toast } from 'react-toastify'


// Base axios instance oluşturuyoruz
const axiosInstance = axios.create({
  baseURL: apiConfig.apiAdress(),
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor - her istekte token'ı ekler
axiosInstance.interceptors.request.use(
  async config => {

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Response interceptor - hata yönetimi için
axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config

    // 401 hatası durumunda oturum sonlandırma
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      // Burada refresh token işlemi yapılabilir
      // Şimdilik sadece oturumu sonlandırıyoruz
      window.location.href = '/login'

      return Promise.reject(error)
    }

    // if (error.response?.status === 403) {
    //   // Şimdilik sadece oturumu sonlandırıyoruz
    //   window.location.href = '/notfound'

    //   return Promise.reject(error)
    // }

    const errors = error.response?.data?.errors || [error.response?.data?.message] || ['Bir hata oluştu']

    errors.forEach((err: string) => {
      toast.error(err)
    })

    return Promise.reject(error)
  }
)

// API istekleri için helper fonksiyonlar
export const api = {
  get: <T>(url: string, config = {}) => axiosInstance.get<T>(url, config),

  post: async (url: string, data?: any, config = {}) => {
    try {
      const response = await axiosInstance.post(url, data, config)

      if ('isSuccess' in response.data && response.data.isSuccess) {
        toast.success(response.data?.message || 'İşlem başarılı')
      }

      if ('isSuccess' in response.data && response.data.isSuccess == false) {
        toast.error(response.data?.message || 'İşlem başarısız')
      }

      return response
    } catch (error) {
      return Promise.reject(error)
    }
  },

  put: async (url: string, data?: any, config = {}) => {
    try {
      const response = await axiosInstance.put(url, data, config)

      if (response.data?.isSuccess) {
        toast.success(response.data?.message || 'İşlem başarılı')
      }

      if (response.data?.isSuccess == false) {
        toast.error(response.data?.message || 'İşlem başarısız')
      }

      return response
    } catch (error) {
      return Promise.reject(error)
    }
  },

  delete: async (url: string, config = {}) => {
    try {
      const response = await axiosInstance.delete(url, config)

      if (response.data?.isSuccess) {
        toast.success(response.data?.message || 'İşlem başarılı')
      }

      return response
    } catch (error) {
      return Promise.reject(error)
    }
  },

  patch: <T>(url: string, data?: any, config = {}) => axiosInstance.patch<T>(url, data, config),

}

export default axiosInstance
